module.exports = __webpack_public_path__ + "static/media/image4.17b45f82.jpg";